import { put } from 'redux-saga/effects';

import * as actions from '../../actions';

// eslint-disable-next-line import/prefer-default-export
export function* showLoginFormPage({ payload }) {
  yield put(actions.loginFormErrorMsg(null));
  yield put(actions.showLoginFormPage(payload));
}
